import Icon from "@ant-design/icons";

const icon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    className="mb-0"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M4.43336 2.90039H0.866699V14.667H4.43336V2.90039Z"
        fill="#E8EAE9"
      />
      <path
        d="M15.0999 2.90039H11.5332V14.667H15.0999V2.90039Z"
        fill="#E8EAE9"
      />
      <path
        d="M11.5663 1.93359H4.46631V14.6669H11.5663V1.93359Z"
        fill="#F3F3F3"
      />
      <path d="M10.4 3.2666H5.6333V4.53326H10.4V3.2666Z" fill="#55C0EB" />
      <path d="M10.4 6H5.6333V7.26666H10.4V6Z" fill="#55C0EB" />
      <path d="M10.4 8.7002H5.6333V9.96685H10.4V8.7002Z" fill="#55C0EB" />
      <path
        d="M9.53297 11.4004H6.46631V14.7004H9.53297V11.4004Z"
        fill="#415A6B"
      />
      <path d="M12.4331 0H3.56641V1.93334H12.4331V0Z" fill="#F3705A" />
      <path
        d="M3.43359 4.13379H1.93359V6.33379H3.43359V4.13379Z"
        fill="#55C0EB"
      />
      <path
        d="M14.0669 4.13379H12.5669V6.33379H14.0669V4.13379Z"
        fill="#55C0EB"
      />
      <path d="M3.43359 7.7334H1.93359V9.9334H3.43359V7.7334Z" fill="#55C0EB" />
      <path d="M14.0669 7.7334H12.5669V9.9334H14.0669V7.7334Z" fill="#55C0EB" />
      <path d="M3.43359 11.334H1.93359V13.534H3.43359V11.334Z" fill="#55C0EB" />
      <path d="M14.0669 11.334H12.5669V13.534H14.0669V11.334Z" fill="#55C0EB" />
      <path d="M16 14.667H0V16.0003H16V14.667Z" fill="#4EC0AA" />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const IconLand = (props) => <Icon component={icon} {...props} />;

export default IconLand;
